/* Matraws — NY PDP: holo 3D-tilt + foil-glare på display-case galleriet.
   Kun fine pointer (mobil-swipe upåvirket); respekterer reduced-motion. */
(function () {
  if (window.__mtwPp) return;
  window.__mtwPp = 1;

  var ok = window.matchMedia
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bindStage(stage) {
    if (!ok || !stage || stage.__mtwBound) return;
    var card = stage.querySelector('.product-gallery-img.product-media-wrapper');
    if (!card) return;
    stage.__mtwBound = 1;
    stage.classList.add('mtw-holo');

    stage.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      px = Math.max(0, Math.min(1, px));
      py = Math.max(0, Math.min(1, py));
      card.style.setProperty('--ry', ((px - 0.5) * 9).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - py) * 9).toFixed(2) + 'deg');
      card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    });
    stage.addEventListener('pointerleave', function () {
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.mtw-pp [data-mtw-stage]').forEach(bindStage);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Matraws — sticky køb-bar: dukker op når hero-CTA scroller ud af syne,
   spejler pris/tilstand live og udløser den rigtige "Læg i kurv". */
(function () {
  if (window.__mtwPpSticky) return;
  window.__mtwPpSticky = 1;

  function setup() {
    var bar = document.querySelector('[data-mtw-stickybar]');
    if (!bar || bar.__mtwBound) return;
    var scope = bar.closest('.mtw-pp') || document;
    var atc = scope.querySelector('[data-add-to-cart]');
    var anchor = scope.querySelector('.mtw-pp-atc') || atc;
    if (!atc || !anchor) return;
    bar.__mtwBound = 1;

    var sbtn = bar.querySelector('[data-mtw-sticky-atc]');
    if (sbtn) sbtn.addEventListener('click', function () { atc.click(); });

    // Spejl pris live (variant-skift opdaterer hoved-prisen)
    var srcPrice = scope.querySelector('.mtw-pp-price [data-regular-price]') || scope.querySelector('.mtw-pp-price .actual-price');
    var dstPrice = bar.querySelector('[data-mtw-sticky-price]');
    function syncPrice() { if (srcPrice && dstPrice) dstPrice.textContent = srcPrice.textContent.trim(); }
    function syncState() {
      if (!sbtn) return;
      sbtn.disabled = !!atc.disabled;
      var lbl = atc.querySelector('[data-addtocart-text]') || atc;
      var txt = (lbl.textContent || '').trim();
      if (txt) sbtn.textContent = txt;
    }
    syncPrice(); syncState();
    if ('MutationObserver' in window) {
      if (srcPrice) new MutationObserver(syncPrice).observe(srcPrice, { childList: true, subtree: true, characterData: true });
      new MutationObserver(syncState).observe(atc, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    }

    // Vis bar når hero-CTA er ude af syne — men skjul den igen når footeren
    // er i syne, så den ikke dækker bunden af siden (vigtigt på mobil).
    if ('IntersectionObserver' in window) {
      var atFooter = false, ctaGone = false;
      function apply() {
        if (ctaGone && !atFooter) bar.setAttribute('data-show', '');
        else bar.removeAttribute('data-show');
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ctaGone = !e.isIntersecting; });
        apply();
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      io.observe(anchor);

      var footer = document.querySelector('#shopify-section-footer, .section-footer, footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { atFooter = e.isIntersecting; });
          apply();
        }, { threshold: 0 }).observe(footer);
      }
    }
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
})();
